export default "__VITE_ASSET__KzmvnWWH__"